
(function () {
  document.addEventListener("DOMContentLoaded", function () {
    // Accordion filters
    document.querySelectorAll('.filter-group__details').forEach((details) => {
      details.addEventListener('toggle', function () {
        if (details.open) {
          document.querySelectorAll('.filter-group__details').forEach((other) => {
            if (other !== details && other.open) {
              other.open = false;
            }
          });
        }
      });
    });

    // Shopify duplicate error message + dismiss + fade out
    const wrapper = document.querySelector(".product__form__errors");
    if (!wrapper) {
      console.warn("❌ .product__form__errors not found");
      return;
    }

    const observer = new MutationObserver(() => {
      const injected = wrapper.querySelector(".errors");
      if (!injected) return;

      const parts = injected.textContent.split(":");
      if (parts.length === 2 && parts[0].trim() === parts[1].trim()) {
        injected.textContent = parts[0].trim();
        console.log("✅ Shopify duplicate message removed.");
      }

      injected.classList.add("auto-dismissible");

      // Add close button if it doesn't exist
      let closeBtn = injected.querySelector("[data-close-error]");
      if (!closeBtn) {
        closeBtn = document.createElement("button");
        closeBtn.setAttribute("type", "button");
        closeBtn.setAttribute("data-close-error", "true");
        closeBtn.innerHTML = "×";
        closeBtn.style.cssText = "position: absolute; top: 8px; right: 12px; background: none; border: none; font-size: 20px; cursor: pointer;";
        injected.style.position = "relative";
        injected.appendChild(closeBtn);
      }

      const fadeAndRemove = () => {
        injected.classList.add("fade-out");
        setTimeout(() => {
          if (injected && injected.parentNode) {
            injected.remove();
            console.log("✅ Dismissed error.");
          }
        }, 500);
      };

      const timeoutId = setTimeout(fadeAndRemove, 4000);

      closeBtn.addEventListener("click", () => {
        clearTimeout(timeoutId);
        fadeAndRemove();
        console.log("❌ Manually dismissed error.");
      });
    });

    observer.observe(wrapper, { childList: true, subtree: true });
  });
})();





